import { createGlobalStyle, css } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  ${({ theme }) => {
    return css`
      html {
        scroll-behavior: smooth;
        font-size: 14px;

        @media screen and (min-width: ${theme.breakpoint.xl}) {
          font-size: 14px;
        }

        // TODO: REVIEW THESE BREAKPOINTS
        @media screen and (min-width: 1441px) {
          font-size: 16px;
        }

        // TODO: REVIEW THESE BREAKPOINTS MAYBE REMOVE THIS ONE
        //@media screen and (min-width: 1441px) {
        //font-size: 16px;
        //}

        // TODO: CREATE A NEW TOKEN breakpoint_max or xxl2
        //@media screen and (min-width: 1800px) {
        //font-size: 18px;
        //}

        // TODO: CREATE A NEW TOKEN breakpoint_max or xxl2
        @media screen and (min-width: 1921px) {
          //font-size: 18px;
        }
      }

      html,
      body {
        padding: 0;
        margin: 0;
        font-family: var(--font-family-text);
        color: ${theme.color.dark};
      }

      h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
        font-family: var(--font-family-title);
      }

      q,
      blockquote {
        font-family: var(--font-family-mono);
      }

      a {
        color: ${theme.color.secondary_500};
        text-decoration: none;
        &:hover {
          color: ${theme.color.secondary_600};
        }
      }

      // Dont show on mobile
      .hide-sm {
        @media screen and (max-width: ${theme.breakpoint.sm}) {
          display: none !important;
          visibility: hidden !important;
        }
      }

      .termsfeed-com---nb-simple {
        left: 1rem !important;
        bottom: 1rem !important;
        max-width: 22rem !important;
        box-shadow: rgba(74, 74, 74, 0.3) 0 0 4px 0 !important;
        border-radius: 0.5rem !important;
        background: white !important;
      }

      .cc-nb-main-container {
        padding: 1rem !important;
        transform: translateX(0px) !important;
        transition: transform 400ms linear !important;
        &,
        > * {
          font-family: var(--font-family-text) !important;
        }

        .cc-nb-title {
          font-size: ${theme.typography.font_size.text_md} !important;
          margin-bottom: 0.5rem !important;
        }

        .cc-nb-text {
          font-size: ${theme.typography.font_size.text_sm} !important;
        }
      }

      // Buttons
      .cc-nb-okagree,
      .cc-nb-reject,
      .cc-nb-changep,
      .cc-cp-foot-save {
        -webkit-appearance: button !important;
        vertical-align: middle !important;
        user-select: none !important;
        margin-block-start: 0 !important;
        margin-block-end: 0 !important;
        padding-block-start: 0 !important;
        padding-block-end: 0 !important;
        font-size: 1rem !important;
        font-weight: 700 !important;
        padding: 0.5rem 1rem !important;
        text-align: center !important;
        border-radius: 0.275rem !important;
        outline: 0 !important;
        transition: all 0.15s ease-in-out !important;
        display: inline-block !important;
      }

      .cc-nb-okagree,
      .cc-cp-foot-save {
        border-color: ${theme.color.neutral_400} !important;
        background: ${theme.color.secondary_500} !important;
        color: #fff !important;
      }
      .cc-nb-reject {
        background: #6a9ab1 !important;
        color: #fff !important;
        border-color: ${theme.color.neutral_400} !important;
      }

      .cc-nb-buttons-container {
        margin-right: -0.25rem !important;
        .cc-nb-okagree,
        .cc-nb-reject {
          width: calc(50% - 0.25rem) !important;
        }

        .cc-nb-changep {
          width: calc(100% - 0.25rem) !important;
        }
      }

      .termsfeed-com---pc-dialog {
        &,
        > * {
          font-family: var(--font-family-text) !important;
        }

        .cc-cp-foot-byline {
          font-size: ${theme.typography.font_size.text_xs} !important;
        }
      }

      .cc-pc-container {
        border-radius: 0.5rem !important;
        background: transparent !important;
        overflow: hidden !important;
      }

      .cc-pc-head-close,
      .cc-pc-head-lang-select {
        outline: 0 !important;
        &:focus,
        &:active {
          border: 1px solid ${theme.color.secondary_500} !important;
          box-shadow: none !important;
        }
      }

      .cc-pc-head-lang-select {
        &:focus,
        &:active {
          border: 1px solid ${theme.color.secondary_500} !important;
        }
      }

      .termsfeed-com---pc-dialog input[type='checkbox'].cc-custom-checkbox:checked + label:before {
        background: ${theme.color.secondary_500} !important;
      }
    `;
  }};
`;

export default GlobalStyle;
